/**
 * User: Rob Richard
 * Date: 9/23/14
 * Time: 10:47 AM
 */

'use strict';
var _ = require('underscore');

module.exports = {
    _getFinancialAmount: function (prop, currency) {
        var amount = this.get(prop);
        var number;

        if (amount) {
            number = Number(amount.getAmountIn(currency));

            if (!_.isNaN(number)) {
                return number;
            }
        }

    },
    getSubTotal: function (currency) {
        return this._getFinancialAmount('subTotalAmount', currency);
    },
    getSubTotalNum: function () {
        return this.get('subTotalAmount.amount');
    },
    getTotalAmount: function (currency) {
        return this._getFinancialAmount('totalAmount', currency);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/mixins/financialAmountMixin.js
// module id = 47
// module chunks = 62